var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGbp = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_19569_17421)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
  fill: "#F0F0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.65355 3.12939C1.02514 3.94699 0.551297 4.88933 0.275391 5.91305H4.4372L1.65355 3.12939Z",
  fill: "#0052B4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.7242 5.91302C15.4483 4.88933 14.9745 3.94699 14.3461 3.12939L11.5625 5.91302H15.7242Z",
  fill: "#0052B4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.275391 10.0869C0.551328 11.1106 1.02517 12.0529 1.65355 12.8705L4.43711 10.0869H0.275391Z",
  fill: "#0052B4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.8696 1.65358C12.052 1.02517 11.1097 0.551328 10.0859 0.275391V4.43717L12.8696 1.65358Z",
  fill: "#0052B4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.12891 14.3461C3.9465 14.9745 4.88884 15.4483 5.91253 15.7242V11.5625L3.12891 14.3461Z",
  fill: "#0052B4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.9125 0.275391C4.88881 0.551328 3.94647 1.02517 3.12891 1.65355L5.9125 4.43714V0.275391Z",
  fill: "#0052B4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.0859 15.7242C11.1096 15.4483 12.052 14.9745 12.8695 14.3461L10.0859 11.5625V15.7242Z",
  fill: "#0052B4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.5625 10.0869L14.3461 12.8705C14.9745 12.053 15.4483 11.1106 15.7242 10.0869H11.5625Z",
  fill: "#0052B4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.9323 6.95653H9.04353H9.0435V0.0677188C8.70191 0.02325 8.35366 0 8 0C7.64628 0 7.29809 0.02325 6.95653 0.0677188V6.95647V6.9565H0.0677188C0.02325 7.29809 0 7.64634 0 8C0 8.35372 0.02325 8.70191 0.0677188 9.04347H6.95647H6.9565V15.9323C7.29809 15.9768 7.64628 16 8 16C8.35366 16 8.70191 15.9768 9.04347 15.9323V9.04353V9.0435H15.9323C15.9768 8.70191 16 8.35372 16 8C16 7.64634 15.9768 7.29809 15.9323 6.95653Z",
  fill: "#D80027"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.0879 10.0869L13.6578 13.6568C13.822 13.4927 13.9786 13.3211 14.128 13.1432L11.0717 10.0869H10.0879V10.0869Z",
  fill: "#D80027"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.91366 10.0869H5.91359L2.34375 13.6568C2.50787 13.8209 2.67947 13.9776 2.85734 14.127L5.91366 11.0706V10.0869Z",
  fill: "#D80027"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.91317 5.91323V5.91317L2.3433 2.34326C2.17911 2.50739 2.02248 2.67898 1.87305 2.85686L4.92939 5.9132H5.91317V5.91323Z",
  fill: "#D80027"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.0879 5.9132L13.6578 2.34327C13.4937 2.17908 13.3221 2.02245 13.1442 1.87305L10.0879 4.92939V5.9132Z",
  fill: "#D80027"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_19569_17421"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgGbp);
export { ForwardRef as ReactComponent };